var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDelayed = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    width: "100%",
    height: "100%",
    viewBox: "0 0 33 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.638,29.537c-1.648,0 -2.942,-1.354 -2.942,-3.002c0,-1.648 1.353,-3.001 3.001,-3.001c1.648,0 2.943,1.353 2.943,3.06c-0.059,1.589 -1.413,2.943 -3.002,2.943Zm-0.765,-26.955c1.413,-0.353 2.825,0.353 3.473,1.648c0.235,0.471 0.294,1.001 0.235,1.471c-0.118,1.472 -0.177,2.943 -0.235,4.473c-0.118,2.296 -0.295,4.65 -0.412,6.945c-0.059,0.706 -0.059,1.412 -0.118,2.177c-0.059,1.236 -1.001,2.178 -2.237,2.178c-1.177,0 -2.177,-0.942 -2.236,-2.119c-0.176,-3.59 -0.412,-7.18 -0.588,-10.77c-0.059,-0.941 -0.118,-1.942 -0.177,-2.884c0,-1.412 0.942,-2.766 2.295,-3.119Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDelayed);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/delayed.ad1d61ea0a1ea842f4f5c01ffd9d872a.svg";